<template>
  <div
    :class="[
      isAccepted ? 'border border-success' : 'border-primary',
      'card bg-light col-sm-4 mb-4 mr-4',
    ]"
  >
    <div class="card-body d-flex flex-column">
      <h5 class="card-title text-center">
        {{ documentTitle }}
        <span v-if="isAccepted" class="badge badge-success float-right">
          <font-awesome-icon :icon="['far', 'check']"></font-awesome-icon>
        </span>
        <span v-if="needsUpload" class="badge badge-primary float-right">
          <font-awesome-icon :icon="['fad', 'exclamation']"></font-awesome-icon>
        </span>
      </h5>
      <p
        class="card-text font-weight-light d-inline-flex justify-content-center mt-auto"
      >
        {{ description }}
      </p>
      <template v-if="isAccepted">
        <div class="d-inline-flex justify-content-center mt-auto">
          <ehr-button
            button-type-class="btn-success"
            :loading="isLoading"
            :disabled="true"
            icon="check"
            class="mb-4"
            :is-duotone="false"
          >
            <span class="d-none d-sm-inline">Upload voltooid</span>
          </ehr-button>
        </div>
        <div class="d-inline-flex justify-content-center mt-auto">
          <file-list
            class="text-left mb-0"
            label="Bestanden:"
            :files="testFiles"
          >
          </file-list>
        </div>
      </template>
      <template v-if="needsUpload">
        <file-upload
          class="mt-auto"
          label="Bestand uploaden:"
          :upload-percentage="0"
          @files-changed="onFilesChanged"
        >
        </file-upload>
      </template>
    </div>
  </div>
</template>

<script>
import EhrButton from "./../interface/EhrButton.vue";
import FileList from "./../interface/FileList.vue";

import FileUpload from "./../inputs/FileUpload.vue";

export default {
  name: "document-block",
  props: {
    documentTitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    // "accepted" "needs-upload"
    status: {
      type: String,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
    },
    uploadedFiles: {
      type: Array,
      required: false,
    },
  },
  components: {
    EhrButton,
    FileUpload,
    FileList,
  },
  computed: {
    isAccepted() {
      return this.status == "accepted";
    },
    needsUpload() {
      return this.status == "needs-upload";
    },
  },
  methods: {
    onFilesChanged() {
      this.testFiles.map((x) => {
        console.log("test");
      });
    },
  },
  data() {
    return {
      testFiles: [
        {
          bestandsnaam: "test.txt",
          data: new Blob(),
        },
        {
          bestandsnaam: "image.png",
          data: new Blob(),
        },
      ],
    };
  },
};
</script>
